/**
 * The paths anyone may open without signing in: the Wilbur status page (`/status`) and the client
 * status boards (`/status/client/:token`). main.tsx sends them to the public root, which never
 * mounts the sign-in provider. index.html's no-flash script tests the same prefix; keep the two in
 * step.
 */
export const isPublicPath = (pathname: string): boolean =>
  pathname === '/status' || pathname.startsWith('/status/');
